/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".error-wrapper[_ngcontent-%COMP%]{margin:100px 0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;-ms-flex-direction:column;flex-direction:column}.home-icon[_ngcontent-%COMP%]{margin-top:15px;margin-bottom:15px}h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%]{margin-bottom:5px}p[_ngcontent-%COMP%]{margin-bottom:25px}"];
export { styles as styles };
